// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"43191ddc","783":"b8967eca","787":"e9a39ec5"}[chunkId] + ".chunk.js";
};